export const SORT_LIST = 'SORT_LIST';
export const TOGGLE_LIST_SHARE = 'TOGGLE_LIST_SHARE';

export const toggleListShare = (uid: string) => ({
  type: TOGGLE_LIST_SHARE,
  uid,
});
